var _a;
import { ApiErrorCodes } from '@amzn/atoz-shiftapp-utilities';
export var IneligibleReasonMappings = (_a = {},
    _a[ApiErrorCodes['GSF-1000']] = 'HRS_PER_DAY',
    _a[ApiErrorCodes['GSF-1001']] = 'HRS_PER_DAY_AT_SITE',
    _a[ApiErrorCodes['GSF-1002']] = 'HRS_PER_WEEK',
    _a[ApiErrorCodes['GSF-1003']] = 'HRS_PER_WEEK_AT_SITE',
    _a[ApiErrorCodes['GSF-1004']] = 'DAYS_PER_WEEK',
    _a[ApiErrorCodes['GSF-1005']] = 'DAYS_IN_A_ROW',
    _a[ApiErrorCodes['GSF-1006']] = 'DIFF_BETWEEN_END_SHIFT_AND_START_NEW_SHIFT_IN_MINUTES',
    _a[ApiErrorCodes['GSF-1007']] = 'DIFF_BETWEEN_END_NEW_SHIFT_AND_START_SHIFT_IN_MINUTES',
    _a[ApiErrorCodes['GSF-1009']] = 'CLOPENING_REQUIRED_BREAK_IN_HOURS',
    _a[ApiErrorCodes['GSF-1010']] = 'HOURS_WORKED_IN_24_HOUR_SHIFT_WINDOW',
    _a[ApiErrorCodes['GSF-2000']] = 'OVERLAPPING_SHIFT',
    _a[ApiErrorCodes['GSF-2001']] = 'OPPORTUNITY_CAPACITY_MET',
    _a[ApiErrorCodes['GSF-2002']] = 'DUPLICATE_CROSS_TRAINING',
    _a[ApiErrorCodes['AFT-1001']] = 'SHIFT_TYPE_MISMATCH',
    _a[ApiErrorCodes['AFT-1002']] = 'SKILL_MISMATCH',
    _a[ApiErrorCodes['AFT-1004']] = 'MINIMUM_GAP_BETWEEN_SHIFTS_VIOLATION',
    _a[ApiErrorCodes['AFT-1007']] = 'DAYS_IN_A_ROW',
    _a[ApiErrorCodes['AFT-1008']] = 'HRS_PER_WEEK',
    _a[ApiErrorCodes['AFT-1009']] = 'HRS_PER_DAY',
    _a[ApiErrorCodes['AFT-1011']] = 'ASSOCIATE_ABSENT',
    _a[ApiErrorCodes['AFT-1012']] = 'MAX_SHIFTS_PER_DAY_VIOLATION',
    _a[ApiErrorCodes['AFT-1013']] = 'ASSOCIATE_TYPE_MISMATCH_READY_ONLY',
    _a[ApiErrorCodes['AFT-1014']] = 'ASSOCIATE_TYPE_MISMATCH_NON_READY_ONLY',
    _a[ApiErrorCodes['AFT-1015']] = 'SCHEDULE_INVALID_STATE',
    _a[ApiErrorCodes['AFT-1017']] = 'MAX_HOURS_PER_ROLLING_4_MONTH_VIOLATION',
    _a[ApiErrorCodes['AFT-2000']] = 'ASSOCIATE_ACCEPTED',
    _a[ApiErrorCodes['AFT-2001']] = 'SHIFT_OPPORTUNITY_CAPACITY_MET',
    _a[ApiErrorCodes['AFT-2002']] = 'SHIFT_OPPORTUNITY_EXPIRED',
    _a[ApiErrorCodes['AFT-9999']] = 'UNKNOWN',
    _a[ApiErrorCodes['SMS-1001']] = 'SHIFT_TYPE_MISMATCH',
    _a[ApiErrorCodes['SMS-1002']] = 'SKILL_MISMATCH',
    _a[ApiErrorCodes['SMS-1004']] = 'MINIMUM_GAP_BETWEEN_SHIFTS_VIOLATION',
    _a[ApiErrorCodes['SMS-1007']] = 'DAYS_IN_A_ROW',
    _a[ApiErrorCodes['SMS-1008']] = 'HRS_PER_WEEK',
    _a[ApiErrorCodes['SMS-1009']] = 'HRS_PER_DAY',
    _a[ApiErrorCodes['SMS-1011']] = 'ASSOCIATE_ABSENT',
    _a[ApiErrorCodes['SMS-1012']] = 'MAX_SHIFTS_PER_DAY_VIOLATION',
    _a[ApiErrorCodes['SMS-1013']] = 'ASSOCIATE_TYPE_MISMATCH_READY_ONLY',
    _a[ApiErrorCodes['SMS-1014']] = 'ASSOCIATE_TYPE_MISMATCH_NON_READY_ONLY',
    _a[ApiErrorCodes['SMS-1015']] = 'SCHEDULE_INVALID_STATE',
    _a[ApiErrorCodes['SMS-1016']] = 'MAX_HOURS_PRE_ROLLING_DAY_VIOLATION',
    _a[ApiErrorCodes['SMS-1017']] = 'MAX_HOURS_PER_ROLLING_4_MONTH_VIOLATION',
    _a[ApiErrorCodes['SMS-2000']] = 'ASSOCIATE_ACCEPTED',
    _a[ApiErrorCodes['SMS-2001']] = 'SHIFT_OPPORTUNITY_CAPACITY_MET',
    _a[ApiErrorCodes['SMS-2002']] = 'SHIFT_OPPORTUNITY_EXPIRED',
    _a[ApiErrorCodes['SMS-9999']] = 'UNKNOWN',
    _a);
export var HOURS_CAP_INELIGIBILITIES = new Set([
    ApiErrorCodes['GSF-1005'],
    ApiErrorCodes['GSF-1004'],
    ApiErrorCodes['GSF-1000'],
    ApiErrorCodes['GSF-1001'],
    ApiErrorCodes['GSF-1002'],
    ApiErrorCodes['GSF-1003'],
    ApiErrorCodes['GSF-1010'],
    ApiErrorCodes['AFT-1007'],
    ApiErrorCodes['AFT-1008'],
    ApiErrorCodes['AFT-1009'],
    ApiErrorCodes['AFT-1017'],
    ApiErrorCodes['SMS-1007'],
    ApiErrorCodes['SMS-1008'],
    ApiErrorCodes['SMS-1009'],
    ApiErrorCodes['SMS-1016'],
    ApiErrorCodes['SMS-1017'] //'MAX_HOURS_PER_ROLLING_4_MONTH_VIOLATION',
]);
export var OVERLAPS_WITH_SCHEDULE_INELIGIBILITIES = new Set([
    ApiErrorCodes['GSF-2000'],
    ApiErrorCodes['AFT-1000'],
    ApiErrorCodes['SMS-1000'] // OVERLAPPING_SHIFT
]);
